import { memo } from 'react';

import { cn } from '../../../lib/cn';
import { Tooltip } from '../../Tooltip/Tooltip';

interface TextCellProps {
  value: string | null | undefined;
  maxChars?: number;
  className?: string;
}

export const TextCell = memo(function TextCell({
  value,
  maxChars,
  className,
}: TextCellProps) {
  if (value === null || value === undefined) {
    return <span className="text-slate-400">-</span>;
  }

  if (maxChars && value.length > maxChars) {
    const truncated = `${value.slice(0, maxChars)}...`;
    return (
      <Tooltip content={value}>
        <span className={cn('cursor-default', className)}>{truncated}</span>
      </Tooltip>
    );
  }

  return <span className={className}>{value}</span>;
});
